import React from 'react';
import { Ticket, Truck } from 'lucide-react';
import '../assets/MinimalistCouponDisplay.css'; // Assuming scroll animation CSS

const MinimalistCouponDisplay = () => {
  const messages = [
    {
      icon: <Truck className="w-4 h-4 text-[#2d161e]" />,
      text: 'Enjoy Free Shipping on orders above ₹499',
    },
  ];

  return (
    <div className=" ">
      <div className="w-full bg-[#fefaf5] border-y border-[#4c0f2e] overflow-hidden relative ">
        <div className="flex animate-scroll">
          {[...Array(2)].map((_, repeatIndex) => (
            <div key={repeatIndex} className="flex gap-6 whitespace-nowrap">
              {Array.from({ length: 25 }).map((_, index) =>
                messages.map((message, messageIndex) => (
                  <div
                    key={`${repeatIndex}-${index}-${messageIndex}`}
                    className="flex items-center gap-2 p-3 text-[#2d161e] cursor-default hover:bg-[#4c0f2e]/30 transition-colors"
                  >
                    {message.icon}
                    <span className="text-xs font-medium">{message.text}</span>
                  </div>
                ))
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MinimalistCouponDisplay;
